import domContentLoaded from "dom-content-loaded";
import { throttle } from "throttle-debounce";
import $ from "jquery";

domContentLoaded(() => {
  /* メインイメージのアニメーション用 */
  // const $window = $(window);

  // if (sessionStorage.getItem('access')) {
  // 	$('body').removeClass('js_firstAccess').addClass('js_notFirstAccess');
  // } else {
  // 	sessionStorage.setItem('access', true);
  // 	$('.js_top_loadingObj').on('transitionend webkitTransitionEnd', () => {
  // 		$('.js_mv_txt').addClass('is_mv_start');
  // 	});
  // }

  const $window = $(window);

  // 現在の日付を取得
  // const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD形式の日付

  // ローカルストレージから前回のアクセス日を取得
  // const lastAccessDate = localStorage.getItem("lastAccessDate");

  // if (lastAccessDate && lastAccessDate === today) {
  // 	// 同じ日のアクセスの場合
  // 	$('body').removeClass('js_firstAccess').addClass('js_notFirstAccess');
  // } else {
  // 	// 日をまたいだアクセスの場合
  // 	localStorage.setItem('lastAccessDate', today); // 今日の日付を保存
  // 	$('body').removeClass('js_notFirstAccess').addClass('js_firstAccess');
  // }

  /* インスタの埋め込み */
  // const returnInstaIndex = () => {
  // 	if (window.matchMedia('(max-width: 1023px)').matches) {
  // 		return 9;
  // 	}
  // 	return 18;
  // };
  // const instaIndex = returnInstaIndex(); // 1023ピクセル以下は9件、それ以外は18件表示します

  // $.ajax({ // jQueryのajaxでjsonデータを取得します
  // 	type: 'GET',
  // 	url: 'https://graph.facebook.com/v18.0/17841405664664861?access_token=key&fields=name,media{caption,like_count,media_url,thumbnail_url,permalink,timestamp,username}',
  // 	dataType: 'json',
  // 	success(json) {
  // 		const insta = json.media.data;
  // 		for (let i = 0; i < instaIndex; i++) {
  // 			const url = insta[i].thumbnail_url || insta[i].media_url; // 画像の時はそのままで、動画の時はサムネイルを表示します
  // 			const href = insta[i].permalink;

  // 			$('.js_insta_list').append(`
  // 				<li class="un_homeSnsInsta_item">
  // 					<a class="un_homeSnsInsta_link" href="${href}" target="_blank">
  // 						<div class="un_homeSnsInsta_img" style="background-image: url(${url});"></div>
  // 					</a>
  // 				</li>
  // 			`);
  // 		}
  // 	},
  // });
});
